import { ChangeDetectionStrategy, Component, Input, TemplateRef } from "@angular/core";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { NzSubmenuInlineChildComponent } from "ng-zorro-antd/menu";
import { UiMenuModeType } from "../../menu.models";

@Component({
  selector: "[ui-submenu-inline-child]",
  exportAs: "uiSubmenuInlineChild",
  templateUrl: "./submenu-inline-child.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: "ant-menu ant-menu-inline ant-menu-sub",
    "[class.ant-menu-rtl]": `dir === 'rtl'`,
  },
})
export class UiSubmenuInlineChildComponent extends NzSubmenuInlineChildComponent {
  @Input() public templateOutlet: TemplateRef<NzSafeAny> | null = null;
  @Input() public menuClass = "";
  @Input() public mode: UiMenuModeType = "vertical";
  @Input() public nzOpen = false;
}
